import https from '../../utils/requestAI.js';

export const getCityList = (params) => {
    return https.post('/user/city/list', params,{'Content-Type':'application/json;charset=UTF-8'})
}
export const getSchoolList = (params) => {
    return https.post('/user/school/list', params,{'Content-Type':'application/json;charset=UTF-8'})
}
export const getRegister = (params) => {
    return https.post('/user/register', params,{'Content-Type':'application/json;charset=UTF-8'})
}
export const getCourseList = (params) => {
    return https.post('/duo-fen-pai/api/courseList', params,{'Content-Type':'application/json;charset=UTF-8'})
}
export const getCourseDetailList = (params) => {
    return https.post('/duo-fen-pai/api/courseDetailList', params,{'Content-Type':'application/json;charset=UTF-8'})
}
export const getTestList = (params) => {
    return https.post('/duo-fen-pai/api/testList', params,{'Content-Type':'application/json;charset=UTF-8'})
}
export const getTestDetailList = (params) => {
    return https.post('/duo-fen-pai/api/testDetailList', params,{'Content-Type':'application/json;charset=UTF-8'})
}
export const getExamList = (params) => {
    return https.post('/duo-fen-pai/api/examPaperList', params,{'Content-Type':'application/json;charset=UTF-8'})
}
export const getWanxiao = (params) => {
    return https.post('/duo-fen-pai/api/query-wanxiao-packages', params,{'Content-Type':'application/json;charset=UTF-8'})
}
export const getWanxiaoDetail = (params) => {
    return https.post('/duo-fen-pai/api/query-wanxiao-lessons', params,{'Content-Type':'application/json;charset=UTF-8'})
}